import React from 'react';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import _get from 'lodash/get';
import _toLower from 'lodash/toLower';
import _upperFirst from 'lodash/upperFirst';
import styles from './index.module.scss';

import { If } from 'utils';
import { EcommPlatform, UiKit } from 'components';
import { getEcommPlatformLabel, isEcommPlatformSupported } from 'utils/methods';

export default function Store({
  data = {},
  isConnecting = false,
  connectingStore = null,
  onConnect = () => {}
}) {
  const { push } = useHistory();

  const storeUrl = _get(data, 'store_url', '');
  const storeName = _get(data, 'store_name', '');
  const isInstalled = _get(data, 'is_installed', false);
  const ecommPlatform = _get(data, 'ecommerce_platform', '');

  const isProcessing = connectingStore && connectingStore === storeUrl;
  const isSupported = isEcommPlatformSupported(ecommPlatform);
  const isDisabled = !isSupported || !storeUrl || isConnecting;
  const isUnserviceable = isSupported && !storeUrl;
  const storeLabel = getEcommPlatformLabel(
    ecommPlatform,
    _upperFirst(_toLower(ecommPlatform))
  );

  const onConnectStore = () => {
    if (isDisabled) return;
    if (isInstalled) return push('/login');
    onConnect(data);
  };

  return (
    <div className={cn(styles.container, { [styles.disabled]: !isSupported })}>
      <If test={isSupported}>
        <div className={styles.iconWrapper}>
          <EcommPlatform.Icon source={ecommPlatform} className={styles.icon} />
        </div>
      </If>
      <div className={styles.info}>
        <div className={styles.row}>
          <p className={styles.storeName}>{storeName}</p>
          <If test={isInstalled}>
            <UiKit.Tag mode="dark" size="sm" className="ml-2">
              Activated
            </UiKit.Tag>
          </If>
        </div>
        <div className={styles.row}>
          <p className={styles.ecommPlatform}>{storeLabel}</p>
          <If test={storeUrl}>
            <div className={styles.separator} />
            <p className={styles.storeUrl}>{storeUrl}</p>
          </If>
        </div>
      </div>
      <UiKit.Tooltip disabled={!isUnserviceable}>
        <UiKit.Tooltip.Trigger>
          <UiKit.Button
            variant="secondary"
            onClick={onConnectStore}
            processing={isProcessing}
            disabled={isDisabled || isUnserviceable}
          >
            {isInstalled ? 'Login' : 'Activate'}
          </UiKit.Button>
        </UiKit.Tooltip.Trigger>
        <UiKit.Tooltip.Content>
          Store URL is missing. Please add your store URL to activate.
        </UiKit.Tooltip.Content>
      </UiKit.Tooltip>
    </div>
  );
}
